import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import * as ProviderActions from "../../../../Redux/actions/providerActions";
import BlankProvider from "../providers/blankProviderBSC";
import plusImage from "../../../../../static/images/plus.svg";
import TableClientsByProvider from "../../table/table-clients-provider";
import { getRoles } from "../../../../Redux/reducer/session";
import { loadingModal, moduleAction } from "../../../utils/functions";
import {
  getAllProviders,
  getTotalElements,
} from "../../../../Redux/reducer/providers";
import { MOD_CUSTOM, WRITE } from "../../../../permissions";
import FilterComponent from "../../../utils/searchBar";
import i18next from "i18next";

const filters = [
  {
    name: i18next.t(`general.placeholders.name`),
    property: "company.institution.name",
    operator: "eq",
  },
  {
    name: i18next.t(`general.placeholders.id`),
    property: "company.institution.businessId",
    operator: "eq",
  },
  {
    name: "Cif",
    property: "company.institution.cif",
    operator: "eq",
  },
];

const LoadProviders = ({ changeStep, providerId }) => {
  const [state, setState] = useState({
    componentReady: false,
    page: 0,
    totalSize: 0,
    sizePerPage: 10,
  });

  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState(false);

  const { proveedores, totalElements, roles } = useSelector((state) => ({
    roles: getRoles(state),
    proveedores: getAllProviders(state),
    totalElements: getTotalElements(state),
  }));

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const defaultSearch = {
    property: "mycustomer_provider.id",
    operator: "eq",
    value: providerId,
  };

  const getInitialData = async (page = 0, sizePerPage = 10, filters = []) => {
    setLoading(true);
    setState({ ...state, page, sizePerPage });

    await dispatch(
      ProviderActions.getAllProviders(page, sizePerPage, [
        ...filters,
        defaultSearch,
      ])
    );
    setState({ ...state, page, sizePerPage, componentReady: true });
    setLoading(false);
  };

  const showDetails = () => setDetails((prev) => !prev);

  const search = async (searchProperty, searchTerm) => {
    if (searchTerm === "") {
      await dispatch(
        ProviderActions.getAllProviders(state.page, state.sizePerPage, [
          defaultSearch,
        ])
      );
    } else {
      let operator = "";

      filters.map((item) => {
        if (item.property === searchProperty) {
          operator = item.operator;
        }
      });

      const actionFilters = [
        defaultSearch,
        {
          property: searchProperty,
          operator: operator,
          value: searchTerm,
        },
      ];

      await dispatch(
        ProviderActions.getAllProviders(
          state.page,
          state.sizePerPage,
          actionFilters
        )
      );
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);

  const { page, sizePerPage, componentReady } = state;

  return (
    <>
      {componentReady &&
        (proveedores?.length ? (
          <>
            <div className="add-header-button">
              {!details && (
                <>
                  {moduleAction(roles, MOD_CUSTOM, WRITE) && (
                    <div className="action-add" onClick={changeStep}>
                      <p>{t(`clients.addClient`)}</p>
                      <img
                        className="icon-plus--account"
                        src={plusImage}
                      />
                    </div>
                  )}
                  <FilterComponent searchFnc={search} filter={filters} />
                </>
              )}
            </div>
            <TableClientsByProvider
              page={page}
              details={details}
              data={proveedores}
              sizePerPage={sizePerPage}
              totalSize={totalElements}
              showDetails={showDetails}
              getAllProviders={getInitialData}
            />
          </>
        ) : (
          <BlankProvider onClick={changeStep} />
        ))}
      {loading && loadingModal()}
    </>
  );
};

export default LoadProviders;
